var exports = {
  "lI": "DateOfBirthField.module__fieldset___TWp2M1",
  "_A": "DateOfBirthField.module__labelContainer___TWp2M1",
  "o1": "DateOfBirthField.module__legend___TWp2M1",
  "$K": "DateOfBirthField.module__inputsContainer___TWp2M1",
  "EN": "DateOfBirthField.module__fieldsRow___TWp2M1",
  "tZ": "DateOfBirthField.module__monthField___TWp2M1",
  "bc": "DateOfBirthField.module__dayField___TWp2M1",
  "Y9": "DateOfBirthField.module__yearField___TWp2M1",
  "kc": "DateOfBirthField.module__errorText___TWp2M1",
  "Kd": "DateOfBirthField.module__nativeDateInput___TWp2M1",
};

module.exports = exports;
